import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

//import IndexPage from "../components/Pages/Index/Index";
import IndexPage from "../components/Pages/Index/IndexNew";
import Vision from "../components/Pages/Vision/Vision";
import Concept from "../components/Pages/Concept/Concept";
import Progress from "../components/Pages/Progress/Progress";
import Audition from "../components/Pages/Audition/Audition";
// import AuditionEnter from "../components/Pages/Audition/AuditionEnter";
//import AuditionCard from "../components/Pages/Audition/AuditionCard";
import PrintGallery from "../components/Pages/PrintGallery/PrintGallery";
import Contact from "../components/Pages/Contact/Contact";
import Imprint from "../components/Pages/Imprint/Imprint";
import Privacy from "../components/Pages/Privacy/Privacy";

import { BasePageGrid } from "../playground/BasePageGrid";

class Routes extends Component {
  render() {
    return (
      <Switch>
        <Route path="/" exact component={IndexPage} />
        <Route path="/vision" exact component={Vision} />
        <Route path="/concept" component={Concept} />
        <Route path="/progress" component={Progress} />
        <Route path="/contact" component={Contact} />
        <Route path="/imprint" component={Imprint} />
        <Route path="/privacy" component={Privacy} />
        <Route path="/audition" component={Audition} />
        <Route path="/prints" component={PrintGallery} />
        <Route path="/playground" component={BasePageGrid} />
        <Route
          render={function () {
            return <h1>Not Found</h1>;
          }}
        />
      </Switch>
    );
  }
}

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/routes.js